/* eslint-disable spire/export-styles */
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    productText: string;
}

type Props = OwnProps;

export interface ProductListProductTextStyles {
    productText?: InjectableCss;
}

export const productInformationStyles: ProductListProductTextStyles = {
    productText: {        
        css: css`
            color: #5B5B5B;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            margin-bottom: 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;  
            overflow: hidden;
        `,
    }
};

const styles = productInformationStyles;

const ProductText = ({
    productText,    
}: Props) => {
    return (        
        <Typography {...styles.productText}>
          {productText}
        </Typography>
    );
};

export default ProductText;
